module.exports = __webpack_public_path__ + "img/media_20240408_224931_5455912230220594175.934cb5f8.jpg";